import React from 'react';

import { PopupContentWrapper, PopupActionBar } from '../../../../components';
import {
  PromisedAgreementCheckbox,
  OtherPaymentButtonLinkConnected,
  PromisedPaymentMethodsText,
  PromisedWarning,
  SubmitButtonConnected,
  PromisedTitle,
  PromisedTrustPaymentSection,
} from './connected';

export const Promised = () => (
  <PopupContentWrapper>
    <PromisedTitle />
    <PromisedPaymentMethodsText />
    <PromisedTrustPaymentSection />
    <PromisedWarning />
    <PromisedAgreementCheckbox />

    <PopupActionBar column>
      <SubmitButtonConnected />
      <OtherPaymentButtonLinkConnected />
    </PopupActionBar>
  </PopupContentWrapper>
);
